<template>
  <v-container>
    <div class="text-h6 pa-4 text-center">
      招待したいメンバーのスマートフォンでカメラやQRコードリーダーを開き、QRコードを読み取ってください。
    </div>

    <div class="text-center items-center">
      <vue-qrcode
        v-if="invitationUrl"
        :value="invitationUrl"
        :options="{ width: 300 }"
        tag="img"
        style="margin: auto"
      ></vue-qrcode>
    </div>
  </v-container>
</template>

<script>
import { MESSAGES } from "@/const/message";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { mapActions } from "vuex";

export default {
  name: "QrInvitation",
  components: {
    VueQrcode,
  },
  mixins: [errorHandlerMixin()],
  data: () => ({
    token: "",
  }),
  computed: {
    // 招待用URL
    invitationUrl() {
      return location.origin + "/member-assign?invitation_token=" + this.token;
    },
  },
  created() {
    // メンバー招待用tokenを取得
    this.getIvitationUrl();
  },
  methods: {
    ...mapActions("api", ["incrementRunningApiCount", "decrementRunningApiCount"]),

    // メンバー招待用tokenを取得
    async getIvitationUrl() {
      try {
        this.incrementRunningApiCount();

        const getInvitationTokenFunction = this.$httpsCallable(
          this.$functions,
          "getinvitationtoken"
        );
        const res = await getInvitationTokenFunction();
        this.token = res.data.token;
      } catch (error) {
        this.showError(MESSAGES.ERRORS.UNEXPECTED);
      } finally {
        this.decrementRunningApiCount();
      }
    },
  },
};
</script>
